import { Avatar, Button, Stack } from "@mui/material";
import { CustomCardView } from "../../../component/CustomCardView";
import { CustomTextView } from "../../../component/CustomTextView";
import moment from "moment";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../../data/colors/Colors";
import { Customer } from "../../../../domain/model/Customer";
import { ROUTE_ENDPOINTS } from "../../../../data/constant/RouteConstants";

interface props {
  isVertical: boolean;
  customer: Customer;
  index: number;
}

export function CustomersListItemView(props: props) {
  return (
    <Button
      sx={{ p: 0, borderRadius: 33, textTransform: "none" }}
      fullWidth
      LinkComponent={"a"}
      href={ROUTE_ENDPOINTS.HOME_CUSTOMERS + "/" + props.customer._id}
    >
      <CustomCardView
        padding={0.5}
        width={"100%"}
        borderRadius={33}
        children={
          <Stack
            direction={"row"}
            spacing={1}
            width={"100%"}
            alignItems={"center"}
          >
            <Avatar
              src={props.customer.profileImage}
              sx={{ width: 70, height: 70 }}
            />
            <Stack maxWidth={"70%"} spacing={0}>
              <Stack>
                <CustomTextView
                  text={props.customer.name}
                  variant="body2"
                  fontWeight="bold"
                  props={{
                    flexWrap: "wrap",
                    wordWrap: "break-word",
                  }}
                />
                <CustomTextView
                  text={props.customer.user?.email}
                  variant="subtitle2"
                  textColor={COLOR_LESS_BLACK}
                  fontWeight="300"
                  props={{
                    flexWrap: "wrap",
                    wordWrap: "break-word",
                  }}
                />
              </Stack>
              <CustomTextView
                text={`joined ${moment(
                  props.customer.user?.createdAt
                ).fromNow()}`}
                variant="caption"
                textColor={COLOR_LIGHT_GRAY}
              />
            </Stack>
          </Stack>
        }
      />
    </Button>
  );
}
